export const endpoint = {
	base: "",
	videog: "/videog",
	materialApi: "/materialApi",
} as const;
